import { render, staticRenderFns } from "./TasinirHacizTalimatiForm.vue?vue&type=template&id=0021a9c1&scoped=true"
import script from "./TasinirHacizTalimatiForm.vue?vue&type=script&lang=ts"
export * from "./TasinirHacizTalimatiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0021a9c1",
  null
  
)

export default component.exports